import { render, staticRenderFns } from "./keywordModal.vue?vue&type=template&id=f62385f0&scoped=true"
import script from "./keywordModal.vue?vue&type=script&lang=js"
export * from "./keywordModal.vue?vue&type=script&lang=js"
import style0 from "./keywordModal.vue?vue&type=style&index=0&id=f62385f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f62385f0",
  null
  
)

export default component.exports